module.exports = __webpack_public_path__ + "img/trash.955165b0.svg";